import { X } from 'lucide-react';
import React from 'react';
import { IconButton } from './Button';

export function Chip({
  label,
  onDelete = undefined,
  onClick = undefined,
  className = '',
}) {
  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete?.(e);
  };

  return (
    <span
      className={`chip ${className}`.trim()}
      role={onClick ? 'button' : undefined}
      onClick={onClick}
    >
      <span className="chip__label">{label}</span>
      {onDelete && (
        <IconButton
          className="chip__delete"
          onClick={handleDelete}
          aria-label="Remove"
        >
          <X size={14} />
        </IconButton>
      )}
    </span>
  );
}
